export const MAX_VIEWPORT_WIDTH = 1280;
export const OUTSIDE_COLOR = 0x00000;

export const WORLD_HEIGHT = 15000;
export const WORLD_WIDTH = 15000;

export const GROUND_COLOR = 0x89c0fb;

export const BOUND_WRAP_PADDING = 0;

export const MAX_HP = 500;
